(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoBachilleratoRegenerarService', ReporteEvaluativoBachilleratoRegenerarService);

    ReporteEvaluativoBachilleratoRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoBachilleratoRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteBachillerato:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteBachilleratoregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
